<h4 *ngIf="showOnLineDetails">{{ contentData?.monthlyCharges }}</h4>
<div class="p-content">
  <ng-container>
    <div class="row" *ngIf="lineBillingDetails">
      <div [ngClass]="{ 'm-t-lg': showOnLineDetails }" class="col-12">
        <h5>{{ contentData?.activeProducts }}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="lead m-t-lg">
          {{ contentData?.currentBillCycle }}
          {{ customerAccountBillingDetails?.billCycleStartDate }} -
          {{ customerAccountBillingDetails?.billCycleEndDate }}
        </p>
      </div>
    </div>
    <div class="row m-t-md" *ngIf="lineBillingDetails?.plan">
      <div class="col-12">
        <p class="bold">{{ contentData?.plan }}</p>
      </div>
    </div>
    <ng-container *ngIf="lineBillingDetails?.plan">
      <div class="row">
        <div class="col-8 col-md-10 m-t-md">
          <p class="small">{{ lineBillingDetails?.plan?.name }}</p>
          <p class="xsmall m-t-xs" *ngIf="!showOnLineDetails">
            {{ lineBillingDetails?.plan?.description }}
          </p>
        </div>
        <div class="col-4 col-md-2 m-t-md text-end">
          <p
            class="small"
            tmoCurrencyFormatter
            [currencyValue]="lineBillingDetails?.plan?.price"
            [currencyCode]="'USD'"
            [symbolDisplay]="'symbol'"
          ></p>
        </div>
      </div>
    </ng-container>
    <div class="row m-t-lg" *ngIf="lineBillingDetails?.services?.length > 0">
      <div class="col-12">
        <p class="bold">{{ contentData?.services }}</p>
      </div>
    </div>
    <ng-container *ngIf="lineBillingDetails?.services?.length > 0">
      <div class="row" *ngFor="let services of lineBillingDetails?.services">
        <div class="col-8 col-md-10 m-t-md" *ngIf="!services?.thirdPartyService">
          <p class="small">{{ services?.name }}</p>
          <p class="xsmall m-t-xs" *ngIf="!showOnLineDetails">{{ services?.description }}</p>
        </div>
        <div class="col-4 col-md-2 m-t-md text-end" *ngIf="!services?.thirdPartyService">
          <p
            class="small"
            tmoCurrencyFormatter
            [currencyValue]="services?.price"
            [currencyCode]="'USD'"
            [symbolDisplay]="'symbol'"
          ></p>
        </div>
      </div>
    </ng-container>
    <div class="row m-t-lg" *ngIf="thirdPartyServiceArray?.length > 0">
      <div class="col-12">
        <p class="bold">{{ contentData?.thirdPartyServices }}</p>
      </div>
    </div>
    <ng-container *ngIf="thirdPartyServiceArray?.length > 0">
      <div class="row" *ngFor="let thirdPartyService of thirdPartyServiceArray">
        <div class="col-8 col-md-9 m-t-md">
          <p class="small">{{ thirdPartyService?.name }}</p>
          <p class="xsmall m-t-xs" *ngIf="!showOnLineDetails">
            {{ thirdPartyService?.description }}
          </p>
        </div>
        <div class="col-4 col-md-3 m-t-md text-end">
          <p
            class="small"
            tmoCurrencyFormatter
            [currencyValue]="thirdPartyService?.price"
            [currencyCode]="'USD'"
            [symbolDisplay]="'symbol'"
          ></p>
        </div>
      </div>
    </ng-container>
    <div
      class="row"
      *ngIf="
        lineBillingDetails?.discounts?.length > 0 &&
        lineBillingDetails?.discounts[0]?.description &&
        lineBillingDetails?.discounts[0]?.amount
      "
    >
      <div class="col-12 m-t-lg">
        <p class="bold">{{ contentData?.currentDiscounts }}</p>
      </div>
      <ng-container *ngFor="let discounts of lineBillingDetails?.discounts; let ind = index">
        <div class="col-8 col-md-9 m-t-md">
          <p class="small">
            {{ discounts?.description
            }}<a
              class="tooltip-i m-l-xs"
              aria-label="Clickable action"
              id="cta-default-630_{{ ind }}"
            ></a>
          </p>
        </div>
        <div class="col-4 col-md-3 m-t-md text-end">
          <p class="small">{{ discounts?.amount | currency: 'USD' : 'symbol-narrow' }}</p>
        </div>
        <div class="col-8 col-md-10" *ngIf="discounts?.recurringDiscount">
          <p class="xsmall m-t-xs text-disabled">
            {{ contentData?.reoccuringDiscountNotification }}
          </p>
        </div>
      </ng-container>
    </div>
    <div class="row">
      <div class="col-8 col-md-9 m-t-lg">
        <p class="bold">{{ contentData?.currentMonthlyCharges }}</p>
      </div>
      <div class="col-4 col-md-3 m-t-lg text-end">
        <p
          class="bold"
          tmoCurrencyFormatter
          [currencyValue]="lineBillingDetails?.currentRecurringAmount"
          [currencyCode]="'USD'"
          [symbolDisplay]="'symbol'"
        ></p>
      </div>
      <div class="col-8 col-md-10">
        <p class="xsmall m-t-xs text-disabled">{{ contentData?.nextBillCycleNotification }}</p>
      </div>
    </div>
  </ng-container>
</div>
